import type { NavImpactSurfaces } from '../AutotestNavImpactStats';

export const spec = (): Partial<NavImpactSurfaces> => ({});
